const E = "flyout.expanded", e = "flyout.collapsed", s = class s extends CustomEvent {
  constructor() {
    super(E, { bubbles: !0, composed: !0 });
  }
};
s.EXPANDED_EVENT = E;
let o = s;
const t = class t extends CustomEvent {
  constructor() {
    super(e, { bubbles: !0, composed: !0 });
  }
};
t.COLLAPSED_EVENT = e;
let a = t;
export {
  e as COLLAPSED_EVENT,
  E as EXPANDED_EVENT,
  a as FlyoutCollapsedEvent,
  o as FlyoutExpandedEvent
};
//# sourceMappingURL=FlyoutEvent.js.map
